/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AchFeeInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AchFeeInput({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/Settings/Content/FeeMode/PlatformFee/AchFeeInput",
  disabled,
  isInvalid,
  onChange
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let providerAccountAchFeePercentValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'ach_fee_percent',
})
let providerAccountAchFeePercentIsValidData = fromData.useDataIsValid({ viewPath,
context: 'provider_account',
path: 'ach_fee_percent',
validate: fromHelpers.validateNumber,
required: true,
})
let providerAccountAchFeePercentChangeData = fromData.useDataChange({ viewPath,
context: 'provider_account',
path: 'ach_fee_percent',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="AchFeeInput.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-2oTLV9': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInputLabel
  viewPath={`${viewPath}/TysiaInputLabel`}
 width={80}
 text="ACH"
/>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 size="small"
 maxWidth={60}
 marginTop={0}
 min={0}
 max={5}
 disabled={disabled}
 data="provider_account.ach_fee_percent"
 validate="helpers.js validateNumber"
 invalid={!providerAccountAchFeePercentIsValidData}
 required={true}
 value={providerAccountAchFeePercentValueData}
 onChange={providerAccountAchFeePercentChangeData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="number"
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
<div
  data-testid="AchFeeInput.Vertical"
  data-view-path={viewPath}
 style={{'--ml-2-2oTLV9': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="%"
/>
</div>
</div>
{children}
</React.Fragment>)
}